import * as React from 'react'

import MuteSwitcher from './muteSwitcher'
import VolumeSlider from './volumeSlider'

import * as styles from './audioControls.module.css'

interface IProps {
  muted: boolean
  onMute: () => any
  onUnmute: () => any
  volumeLevel: number
  setVolumeLevel: (volumeLevel: number) => any
}

const AudioControls = ({
  muted,
  onMute,
  onUnmute,
  volumeLevel,
  setVolumeLevel
}: IProps) => {
  return (
    <div className={styles.root}>
      <MuteSwitcher muted={muted} onMute={onMute} onUnmute={onUnmute} />
      <VolumeSlider
        muted={muted}
        volumeLevel={volumeLevel}
        setVolumeLevel={setVolumeLevel}
        onMute={onMute}
        onUnmute={onUnmute}
      />
    </div>
  )
}

export default AudioControls
